

const JsonDisplay = ({ data }) => (
  data && (
  <pre style={{
    backgroundColor: '#f5f5f5',
    padding: '15px',
    borderRadius: '4px',
    overflowX: 'auto',
    fontSize: '14px',
    lineHeight: '1.5',
    border: '1px solid #ddd',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    maxWidth: '100%',
    width: '100%',
  }}>
    {typeof data ==='string' ? data
    : JSON.stringify(data, null, 2)
    } 
    
  </pre>)
);

export default JsonDisplay;